"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const usePrismicPreviewStore = require("../usePrismicPreviewStore.cjs");
const getDocument = (prismicId) => {
  const state = usePrismicPreviewStore.usePrismicPreviewStore.getState();
  return state.documents[prismicId];
};
exports.getDocument = getDocument;
//# sourceMappingURL=getDocument.cjs.map
